<template>
	<div>
		<div @click="showManager()">
			<ReliabilityBadge :member="member" />
		</div>

		<v-dialog v-model="managerDialog" max-width="750px">
			<v-card class="pa-2" v-if="managerDialog">
				<v-card-title>
					<div>
						<span class="headline">وضعیت خوش حسابی</span>
						{{ '(' }}
						<label class="ml-1">نام مشتری:</label>&nbsp;
						<label class="secondary--text">{{ localMember.fullName }}</label>&nbsp;
						<label class="ml-1 mr-5">کد ملی:</label>&nbsp;
						<label class="secondary--text">{{ localMember.nationalCode }}</label>
						{{ ')' }}
					</div>
					<v-spacer />
					<v-btn @click="managerDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-alert v-if="!checkActivePart('reliability')" type="error" outlined>ماژول خوش حسابی برای شما فعال نمی باشد.</v-alert>
					<div v-else>
						<div v-if="loading">
							<v-progress-linear class="mt-3" color="primary" height="4" indeterminate rounded></v-progress-linear>
							<v-alert type="warning" icon="mdi-timer-sand" outlined>
								در حال دریافت اطلاعات...
							</v-alert>
						</div>
						<div v-else>
							<v-tabs v-model="activeTab" background-color="transparent" centered color="secondary" slider-color="secondary">
								<v-tab :key="0">وضعیت مشتری</v-tab>
								<v-tab :key="1">مدیریت وضعیت ها</v-tab>
								<v-tabs-items v-model="activeTab">
									<v-tab-item :key="0" class="pt-5">
										<v-card color="#eee" class="pa-2 py-5 mb-2" elevation="0">
											<div class="d-flex align-center justify-center flex-column">
												<div class="d-flex mb-4 align-center">
													<label class="ml-1">
														وضعیت خوش حسابی:
													</label>
													<ReliabilityBadge v-if="!memberEditMode" :member="member" />
													<div class="d-flex align-center" v-else>
														<v-select v-model="selectedReliability" hide-details :items="items" class="mx-2 mt-0" item-text="title" item-value="id"></v-select>
														<v-btn color="secondary" size="small" small class="mx-1" :loading="updateMemberReliabilityLoading" @click="updateMemberReliabilityManualy()">ذخیره</v-btn>
														<v-btn small class="" @click="memberEditMode = false">انصراف</v-btn>
													</div>
												</div>
												<v-btn color="secondary" small class="mx-2 mb-2" @click="memberEditMode = true">
													<v-icon class="ml-1">mdi-square-edit-outline</v-icon>
													ویرایش دستی وضعیت
												</v-btn>
												<v-btn color="info" small class="" @click="updateMemberReliabilityAuto(true)" :loading="updateMemberReliabilityLoading">
													<v-icon class="ml-1">mdi-refresh</v-icon>
													آپدیت خودکار وضعیت
												</v-btn>
											</div>
										</v-card>
									</v-tab-item>
									<v-tab-item :key="1" class="pt-5">
										<div class="text-center mb-2">
											لیست وضعیت های موجود:
										</div>
										<v-alert type="error" outlined dense v-if="!items.length">تاکنون وضعیتی ثبت نشده است</v-alert>
										<div>
											<div class="d-flex justify-end mb-2">
												<v-btn v-if="items.length" color="secondary" class="mx-1" outlined small @click="updateMemberReliabilityAuto(false)" :loading="updateMemberReliabilityLoading">
													<v-icon class="ml-1">mdi-refresh</v-icon>
													آپدیت خودکار وضعیت همه مشتریان
												</v-btn>
												<v-btn v-else color="secondary" class="mx-1" outlined small @click="add()">
													<v-icon class="ml-1">mdi-plus</v-icon>
													افزودن وضعیت
												</v-btn>
												<v-btn color="info" outlined small class="" @click="insertDefaultItems()">
													<v-icon class="ml-1">mdi-list-box-outline</v-icon>
													افزودن وضعیت های پیش فرض
												</v-btn>
											</div>
											<v-card class="mb-2 pa-5 pb-1" color="#eee" elevation="0" v-for="(rel, index) in items" :key="rel.id + index">
												<v-form :ref="'form' + index" lazy-validation @submit.prevent="save(rel, index)">
													<v-row class="">
														<v-col cols="12" md="4" class="d-flex py-0 my-0">
															<label class="ml-1 pt-2">عنوان:</label>
															<span v-if="!rel.editMode" class="pt-2">{{ rel.title }}</span>
															<v-text-field v-else dense outlined v-model="rel.title" label="" :error-messages="errorMessages" :rules="[(val) => !!val || 'عنوان الزامی است']" required />
														</v-col>
														<v-col cols="12" md="3" class="d-flex py-0 my-0">
															<label class="ml-1 pt-2">رنگ:</label>
															<small v-if="!rel.editMode" style="border-radius: 2px;width: 40px;height: 20px;margin-top: 8px;" :style="{ backgroundColor: rel.color }"></small>
															<input v-else type="color" class="pt-2" v-model="rel.color" />
														</v-col>
														<v-col cols="12" md="5" class="d-flex py-0 my-0">
															<label v-if="!rel.editMode" class="ml-1 pt-2">عدم اجازه ثبت پرونده جدید: {{ rel.isNewLoanLock ? 'بلی' : 'خیر' }}</label>
															<v-checkbox v-else v-model="rel.isNewLoanLock" color="secondary" label="عدم اجازه ثبت پرونده جدید" />
														</v-col>
													</v-row>
													<v-row>
														<v-col cols="12" class="d-flex align-center my-0" :class="[rel.editMode ? 'py-0' : 'pb-4 pt-5']">
															<span style="min-width: 110px;">تعداد روز تاخیر از:</span>
															<span v-if="!rel.editMode" class="text-bold mx-1" style="border-bottom: 1px dashed #ccc;text-align: center;width: 60px;">{{ rel.from }}</span>
															<v-text-field v-else dense type="number" style="max-width:60px" class="mx-1 center-input" v-model="rel.from" :error-messages="errorMessages" :rules="[(val) => val >= 0 || 'مقدار صحیح نیست']" label="" />
															<span style="min-width: 20px;margin-right:15px">تا:</span>
															<span v-if="!rel.editMode" class="text-bold mx-1" style="border-bottom: 1px dashed #ccc;text-align: center;min-width: 60px;">{{ rel.to }}</span>
															<v-text-field v-else dense type="number" style="max-width:60px" class="mx-1 center-input" v-model="rel.to" :error-messages="errorMessages" :rules="[(val) => val >= 0 || 'مقدار صحیح نیست']" label="" />
															<span style="min-width: 75px;">تعداد قسط:</span>
															<span v-if="!rel.editMode" class="text-bold mx-1" style="border-bottom: 1px dashed #ccc;text-align: center;">{{rowTypes.find(x => x.value === rel.rowType).title}}</span>
															<v-select v-else v-model="rel.rowType" :items="rowTypes" style="" class="mx-1" :error-messages="errorMessages" :rules="[(val) => !!val || 'تعداد اقساط الزامی است']" item-text="title" item-value="value"></v-select>
														</v-col>
													</v-row>

													<v-card-actions style="border-top: 1px dashed #ddd;">
														<v-spacer></v-spacer>
														<v-btn v-if="!rel.editMode" @click.prevent="edit(rel)" class="ms-2" small fab dark color="green" title="ویراش">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn v-if="!rel.editMode" @click="remove(rel, index)" class="ms-2" small fab dark color="pink" title="حذف">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" @click="cancel(rel, index)" v-if="rel.editMode" color="grey" small dark>
															انصراف
														</v-btn>
														<v-btn :loading="submitLoading" type="submit" v-if="rel.editMode" color="secondary" small dark>
															ذخیره
														</v-btn>
													</v-card-actions>
												</v-form>
											</v-card>
											<div class="my-2" v-if="items.length">
												<small>راهنما: به عنوان مثال می خواهید افرادی که حداقل سه چهارم از کل اقساط خود را با حداکثر 2 روز تاخیر پرداخت کرده اند را سبز کنید:
												</small>
												<div class="d-flex flex-wrap">
													<small class="ml-3 green--text"><b>از: </b>خالی بگذارید</small>
													<small class="ml-3 green--text"><b>تا: </b>عدد 2 بگذارید</small>
													<small class=" green--text"><b>تعداد قسط: </b>بر روی گزینه حداقل سه چهارم بگذارید</small>
												</div>
											</div>
											<div class="d-flex justify-center" v-if="items.length">
												<v-btn color="secondary" small @click="add()">
													<v-icon class="ml-1">mdi-plus</v-icon>
													افزودن
												</v-btn>
											</div>
										</div>
										<v-card></v-card>
									</v-tab-item>
								</v-tabs-items>
							</v-tabs>
						</div>
					</div>
				</v-card-text>
				<confirm-dlg ref="confirm" />
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import ReliabilityBadge from '@/components/ReliabilityBadge'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'ReliabilityManager',
		props: {
			member: { type: Object, default: null }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ReliabilityBadge: ReliabilityBadge
		},
		data() {
			return {
				selectedReliability: null,
				memberEditMode: false,
				updateMemberReliabilityLoading: false,
				managerDialog: false,
				loading: false,
				submitLoading: false,
				errorMessage: '',
				errorMessages: '',
				activeTab: 5000000,
				items: [],
				localMember: null,
				rowTypes: [
					{ value: 1, title: 'همه اقساط' },
					{ value: 2, title: 'حداکثر یک چهارم اقساط' },
					{ value: 3, title: 'حداکثر دو چهارم اقساط' },
					{ value: 4, title: 'حداکثر سه چهارم اقساط' },
					{ value: 5, title: 'حداقل یک چهارم اقساط' },
					{ value: 6, title: 'حداقل دو چهارم اقساط' },
					{ value: 7, title: 'حداقل سه چهارم اقساط' },
				]
			}
		},
		watch: {
			member: {
				immediate: true,
				handler(val, oldVal) {
					this.localMember = val
					this.selectedReliability = this.localMember?.reliability
				}
			}
		},
		computed: {
		},
		mounted() {
			this.localMember = this.member
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/Reliability/List/')
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error('خطا در دریافت لیست وضعیت ها. ' + err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			loadMember() {
				if (!this.localMember)
					return
				api.get('admin/member/get/' + this.localMember.id, null)
					.then(
						response => {
							this.localMember.reliability = response.reliability
							this.selectedReliability = response.reliability
						})
					.catch(err => {
						toast.error('خطا در دریافت اطلاعات مشتری. ' + err.message)
					})
			},
			update(updatedVal) {

			},
			showManager() {
				this.managerDialog = true
				if (this.checkActivePart('reliability'))
					this.loadData()
			},
			add() {
				this.items.push({
					id: emptyId,
					title: '',
					color: '#000000',
					rowType: 1,
					from: '0',
					to: '0',
					isNewLoanLock: false,
					editMode: true
				})
			},
			edit(item) {
				item.editMode = true
				item.original = JSON.parse(JSON.stringify(item))
			},
			save(item, index) {
				if (this.$refs['form' + index] && !this.$refs['form' + index][0].validate())
					return

				this.submitLoading = true
				api.post('admin/Reliability/' + (item.id === emptyId ? 'create' : 'edit'), item)
					.then(response => {
						item.editMode = false
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
			cancel(item, index) {
				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				item.id = item.original.id
				item.title = item.original.title
				item.color = item.original.color
				item.rowType = item.original.rowType
				item.from = item.original.from
				item.to = item.original.to
				item.editMode = false
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/Reliability/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.items.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			async updateMemberReliabilityAuto(current_member) {
				if (current_member && !this.localMember) {
					toast.error('مشتری یافت نشد.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از انجام این عملیات مطمئن هستید؟',
				)) {
					let ids = current_member ? [this.localMember.id] : []
					this.updateMemberReliabilityLoading = true
					api.post('admin/Reliability/SetMembersReliability', { ids: ids })
						.then(response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.loadMember()
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(x => { this.updateMemberReliabilityLoading = false })
				}
			},
			updateMemberReliabilityManualy() {
				if (!this.localMember) {
					toast.error('مشتری یافت نشد.')
					return
				}

				if (!this.selectedReliability) {
					toast.error('وضعیت تعیین نشده است.')
					return
				}

				this.updateMemberReliabilityLoading = true
				api.post(`admin/Reliability/SetMembersReliabilityManualy/${this.localMember.id}/${this.selectedReliability}`, null)
					.then(response => {
						this.memberEditMode = false
						this.localMember.reliability = this.items.find(x => x.id === this.selectedReliability)
						toast.success('اطلاعات با موفقیت ذخیره شد.')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.updateMemberReliabilityLoading = false })
			},
			insertDefaultItems() {
				let green = {
					id: emptyId,
					title: 'سبز',
					color: '#54D100',
					from: 0,
					to: 5,
					rowType: 0,
					isNewLoanLock: false,
					editMode: true
				}
				let red = {
					id: emptyId,
					title: 'قرمز',
					color: '#DB0000',
					from: 5,
					to: 0,
					rowType: 6,
					isNewLoanLock: true,
					editMode: true
				}

				if (this.items.findIndex(x => x.id === green.emptyId && x.title === green.title && x.color === green.color && x.from === green.from && x.to === green.to) === -1)
					this.items.push(green)

				if (this.items.findIndex(x => x.id === red.emptyId && x.title === red.title && x.color === red.color && x.from === red.from && x.to === red.to) === -1)
					this.items.push(red)
			}
		}
	}
</script>
<style scoped></style>
